<template>
  <div class="bg-white">
    <div
      v-text="$t('common.recommendation_text')"
      class="text-center font-bold font-ff-good-pro-cond text-black text-[22px] leading-8 lg:text-4xl lg:leading-[46px] uppercase"
    ></div>

    <section class="items-stretch mt-4 lg:flex md:mt-10">
      <div class="w-full overflow-hidden md:flex md:flex-row">
        <div
          class="overflow-hidden order-1 xl:flex md:w-1/2 h-[286px] md:h-[550px]"
          data-aos="fade-right"
          data-aos-delay="100"
          data-aos-offset="30"
        >
          <ImgLazyLoader
            src="/warranty/warranty_recommendations_1.png"
            image-class="self-center object-cover object-right w-full h-full xyz-nested"
            alt="recommendation_1"
            class="w-full h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center md:justify-start order-2 overflow-hidden md:w-1/2 py-[30px] px-[15px] sm:p-[30px] lg:p-[90px] md:h-[550px] aos-init aos-animate"
          data-aos="fade-left"
          data-aos-delay="100"
        >
          <div class="md:max-w-[540px]">
            <div
              class="border-b-4 md:w-[108px] w-[86px] h-1 md:h-1.5 mb-[10px] lg:mb-[24px] skew-x-[-50deg] border-primary"
            />

            <p
              class="font-normal text-lg leading-7 lg:text-[34px] lg:leading-[35px] font-ff-good-pro-cond text-black"
              v-text="$t('common.recommendation_section_1_description')"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="items-stretch lg:flex">
      <div class="w-full bg-[#373737] overflow-hidden md:flex md:flex-row">
        <div
          class="overflow-hidden xl:flex md:w-1/2 h-[286px] md:h-[550px] order-1 md:order-2"
          data-aos="fade-left"
          data-aos-delay="100"
          data-aos-offset="30"
        >
          <ImgLazyLoader
            src="/warranty/warranty_recommendations_2.png"
            image-class="self-center object-cover object-right w-full h-full xyz-nested"
            alt="recommendation_1"
            class="w-full h-full"
            xyz="fade small delay-5"
            loading="lazy"
          />
        </div>
        <div
          class="flex items-center md:justify-end order-2 md:order-1 overflow-hidden md:w-1/2 py-[30px] px-[15px] sm:p-[30px] lg:p-[90px] md:h-[550px] aos-init aos-animate"
          data-aos="fade-right"
          data-aos-delay="100"
        >
          <div class="md:max-w-[540px]">
            <div
              class="border-b-4 md:w-[108px] w-[86px] h-1 md:h-1.5 mb-[10px] lg:mb-[24px] skew-x-[-50deg] border-primary"
            />

            <p
              class="font-normal text-lg leading-7 lg:text-[34px] lg:leading-[35px] font-ff-good-pro-cond text-white"
              v-text="$t('common.recommendation_information_description')"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup></script>
